// CompanyNode — the company root, rendered as a static element ABOVE the tree
// (not part of the collapsible hierarchy). Has its own `structure-company`
// styles so its height / spacing / padding can differ from tree rows.

import { Icon, Chip } from '@/components/common';
import { type OrgUnit } from '@/mocks/structure';
import { useLevelConfig } from '@/api/endpoints/levelsApi';

interface CompanyNodeProps {
  unit: OrgUnit;
}

// The company root is display-only — it isn't an editable unit and has no
// select/click behavior (new units default their parent to the root anyway).
const CompanyNode = ({ unit }: CompanyNodeProps) => {
  const level = useLevelConfig()(unit.level);

  return (
    <div className='structure-company'>
      <div className='structure-company__lead'>
        <span className={`structure-company__tile structure-company__tile--${level.tone}`}>
          <Icon name={level.icon} size={22} />
        </span>
        <span className='structure-company__label'>
          <span className='structure-company__name'>{unit.name}</span>
          <span className='structure-company__sub'>{level.name}</span>
        </span>
      </div>

      <div className='structure-company__meta'>
        <Chip variant='brand'>{level.name}</Chip>
      </div>
    </div>
  );
};

export default CompanyNode;
